import React from 'react';

export default
<g id="icon/student/white" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <path d="M14.609375,16.08 C18.089375,17.16 20.609375,20.28 21.209375,24 L2.129375,24 C2.609375,20.28 5.129375,17.16 8.609375,16.08 L11.609375,21.72 L14.609375,16.08 Z M11.609375,8.8817842e-16 L21.209375,6 L17.609375,8.28 C17.609375,11.64 14.969375,14.28 11.609375,14.28 C8.249375,14.28 5.609375,11.64 5.609375,8.28 L2.009375,6 L11.609375,8.8817842e-16 Z" id="Combined-Shape" fill="#FFFFFF" fillRule="nonzero"></path>
</g>
